import { createApi } from "../../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { checkArmedStatus } from "./checkArmedStatus";
import { universalAPIErrorHandler } from "../../../../utils/universalAPIErrorHandler";
import { getNumbersAfterAboutSite } from "../SiteAbout";
import { logger } from "../../../../../utils/logger";
import { summarizeFlexActionResults } from "./summarizeFlexActionResults";
import { requestCameraStatusRefresh } from "./cameraStatusPolling";

export const handleArmSiteFlexSchedules = (
  setBackdropLoadingScreenOn: any,
  setSiteInfo: any,
  setAlertState: any,
  setSyncNeeded: any,
  setArmedStatus: any,
  navigate: any,
  setArmButtonDisabled: any,
  selectedSchedulesArrays: {
    ids: number[];
    names: string[];
  },
  setToolTipTitle: any,
  // "arm" for the Arm toggle's schedule picker; "reboot" when the picker was
  // reached from a reboot-to-apply flow, so the action log records
  // "Manual Reboot" instead of "Manual Arm" (ENG-1404 / SUP-433). Since
  // ENG-1969, a reboot of a schedule that isn't running only deploys
  // settings; the response says which schedules were restarted.
  endpointAction: "arm" | "reboot" = "arm"
) => {
  const AxiosUI = createApi(``);
  setBackdropLoadingScreenOn(true);

  const retryFunction = () => {
    handleArmSiteFlexSchedules(
      setBackdropLoadingScreenOn,
      setSiteInfo,
      setAlertState,
      setSyncNeeded,
      setArmedStatus,
      navigate,
      setArmButtonDisabled,
      selectedSchedulesArrays,
      setToolTipTitle,
      endpointAction
    );
  };

  AxiosUI.post(`flex_schedule/action/${endpointAction}/`, {
    flex_schedule_ids: selectedSchedulesArrays.ids,
  }).then(
    (actionResponse: AxiosResponse) => {
      // The connector restarts: refresh every camera's status (ENG-2853).
      requestCameraStatusRefresh();
      AxiosUI.get(
        `customer/${getNumbersAfterAboutSite(location.href)}/about/`
      ).then(
        (response: AxiosResponse) => {
          checkArmedStatus(
            response.data,
            setArmButtonDisabled,
            navigate,
            setSiteInfo,
            setArmedStatus
          );
          setSiteInfo(response.data);
          if (response.data.settings_deployed !== true) {
            setSyncNeeded(true);
          }
          alert(
            summarizeFlexActionResults(
              actionResponse?.data,
              selectedSchedulesArrays,
              endpointAction
            )
          );
          setArmedStatus(true);
          setBackdropLoadingScreenOn(false);
        },
        (reason: AxiosError) => {
          universalAPIErrorHandler(reason, navigate, retryFunction, () => {
            {
              setAlertState((previousState: any) => {
                return {
                  ...previousState,
                  changeSuccess: false,
                  activateSuccess: false,
                  deactivateSuccess: false,
                  disarmSuccess: false,
                  armSuccess: false,
                  syncSuccess: false,
                  cameraDeleteSuccess: false,
                  armFail: true,
                };
              });
            }
            setBackdropLoadingScreenOn(false);
            logger.log(JSON.stringify(reason.message));
          });
        }
      );
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setBackdropLoadingScreenOn(false);
        setSiteInfo((previousState: any) => {
          return { ...previousState, armed: false };
        });
      });
    }
  );
};
